import PTC_Pedidos from '@/api/PTC/PTC_Pedidos.client';
import { backorderCountFilters, totalBackordersResponse } from '@/utils/pedidoListingRows';

export default {
  namespaced: true,
  state: () => ({
    pedidos: [],
    detalhesPedidoPedido: {},
    ItensPedido: {},
    itens: {},
    totalPedido: {},
    setIsLoading: false,
    filterList: {},
    totalBackorders: null,
    backordersLoading: false,
    backordersError: '',
    backordersRequest: 0,
  }),
  actions: {
    async contarBackorders({ state, commit }, filters = state.filterList) {
      const request = state.backordersRequest + 1;
      commit('SET_BACKORDERS_REQUEST', request);
      commit('SET_BACKORDERS_LOADING', true);
      commit('SET_BACKORDERS_ERROR', '');
      commit('SET_TOTAL_BACKORDERS', null);
      try {
        const response = await new PTC_Pedidos().retornaPedidos(backorderCountFilters(filters));
        const total = totalBackordersResponse(response);
        if (request === state.backordersRequest) commit('SET_TOTAL_BACKORDERS', total);
        return total;
      } catch (error) {
        if (request === state.backordersRequest) {
          commit('SET_BACKORDERS_ERROR', error?.message || 'Não foi possível contar os Back Orders.');
        }
        throw error;
      } finally {
        if (request === state.backordersRequest) commit('SET_BACKORDERS_LOADING', false);
      }
    },
  },
  mutations: {
    SET_BACKORDERS_REQUEST(state, value) { state.backordersRequest = value; },
    SET_BACKORDERS_LOADING(state, value) { state.backordersLoading = value; },
    SET_BACKORDERS_ERROR(state, value) { state.backordersError = value; },
    SET_TOTAL_BACKORDERS(state, value) { state.totalBackorders = value; },
    SET_PEDIDOS(state, data) {
      state.pedidos = data;
      persistirEstado(state);
    },
    SET_DETALHES_PEDIDO(state, data) {
      state.detalhesPedidoPedido = {
        nmr_prdido: validarEObterValor(data.nrPedido_PW),
        dt_emissao: validarEObterValor(data.dataEmissao),
        representante: validarEObterValorConcatenado(data.codRepresentante, data.nomeRepresentante),
        dt_prevista_faturamento: validarEObterValor(data.dataEntrega),
        // Nunca expor o código ERP do cliente no Portal do Cliente.
        cliente: validarEObterValor(data.razaoSocialCliente),
        local_entrega: validarEObterValorConcatenado(
          data.enderecoEntrega,
          data.complementoEnderEntrega,
          `Bairro ${data.bairroEntrega}`,
          `Cidade ${data.cidadeEntrega}`,
          `UF ${data.ufEntrega}`,
          `País ${data.paisEntrega}`,
        ),
        estabelecimento: validarEObterValor(data.estabelecimento),
        tipo: validarEObterValor(data.nomeTipoPedido),
        condicao_pagamento: validarEObterValor(data.nomeCondPagto),
        numero_pedido_cliente: validarEObterValor(data.nrPedidoCliente),
        pedido_representante: validarEObterValor(data.nrPedidoRepres),
        tipo_frete: validarEObterValor(data.tipoFrete),
        transportadora: validarEObterValor(data.nomeTransportadora),
      };
      persistirEstado(state);
    },
    SET_ITENS_PEDIDO(state, data) {
      state.itens = data;
    },
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
      persistirEstado(state);
    },
    SET_FILTROS(state, data) {
      state.filterList = data;
      persistirEstado(state);
    },
    ITENS_PEDIDO(state, data) {
      state.ItensPedido = data;
    },
    TOTAL_PEDIDO(state, data) {
      state.totalPedido = data;
    },
  },
  getters: {
    getPedidos: (state) => state.pedidos,
    getTotalBackorders: (state) => state.totalBackorders,
    getBackordersLoading: (state) => state.backordersLoading,
    getBackordersError: (state) => state.backordersError,
    getIsLoading: (state) => state.setIsLoading,
    getFilterList: (state) => state.filterList,
    getDetalhesPedidoPedido: (state) => state.detalhesPedidoPedido,
    getItensPedido: (state) => state.ItensPedido,
    getTotalPedido: (state) => state.totalPedido,
    getItens: (state) => state.itens,
  },
};

function validarEObterValor(valor) {
  return (valor !== undefined && valor !== null) ? valor : '';
}

function validarEObterValorConcatenado(...valores) {
  const valoresValidos = valores.filter((valor) => valor !== undefined && valor !== null);
  return (valoresValidos.length > 0) ? valoresValidos.join(' ') : '';
}

function persistirEstado(state) {
  // Esta chave legada nunca é restaurada. Persistir todo o módulo (incluindo
  // centenas de pedidos e itens) estoura a cota e faz as mutations lançarem
  // QuotaExceededError, quebrando filtros, detalhes e o próprio loading.
  try {
    localStorage.removeItem('estado');
  } catch (_) {
    // Storage pode estar indisponível; estado de tela continua em memória.
  }
}
